import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sun, X } from "lucide-react";
import { api } from "@/lib/api";

const KEY = "outbound_nudge_dismissed";

export const WeekendNudge = ({ onUse }) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    if (localStorage.getItem(KEY) === new Date().toDateString()) return;
    api.get("/suggestion").then((r) => r.data.show && setS(r.data)).catch(() => {});
  }, []);
  if (!s) return null;
  const dismiss = () => { localStorage.setItem(KEY, new Date().toDateString()); setS(null); };
  return (
    <div data-testid="weekend-nudge" className="relative rounded-2xl bg-[#163A2B] text-white p-4 pr-10 rise">
      <button data-testid="weekend-nudge-dismiss" onClick={dismiss} className="absolute top-3 right-3 text-white/60 hover:text-white"><X className="w-4 h-4" /></button>
      <p className="flex items-center gap-2 font-bold"><Sun className="w-4 h-4 text-amber-300" /> {s.title}</p>
      <p className="text-sm text-white/80 mt-1">{s.message}</p>
      <div className="mt-3 flex items-center gap-3">
        <button data-testid="weekend-nudge-use" onClick={() => { onUse(s.duration_hours); dismiss(); }} className="text-sm font-semibold bg-white text-[#0F2A1F] rounded-lg px-3 py-1.5 hover:bg-amber-50">Set it up</button>
        <Link to="/profile" data-testid="weekend-nudge-settings" className="text-xs text-white/70 underline">Turn these off</Link>
      </div>
    </div>
  );
};
